import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../store/hooks';
import { selectIsAuthenticated } from '../store/slices/authSlice';

interface PublicRouteProps {
  children: React.ReactNode;
  redirectIfAuthenticated?: boolean;
}

export const PublicRoute: React.FC<PublicRouteProps> = ({
  children,
  redirectIfAuthenticated = true
}) => {
  // Obtener estado de autenticación del Redux store
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  // Si está autenticado y se debe redirigir, ir al dashboard
  if (isAuthenticated && redirectIfAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Renderizar sin layout especial (páginas de login/register tienen su propio estilo)
  return <>{children}</>;
};

